var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopArrowSecondary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 716,
    height: 431,
    viewBox: "0 0 716 431",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6599 307.627L307.633 20.9067C321.821 6.71869 339.737 2.78699e-05 358.404 2.78699e-05C377.071 2.78699e-05 394.992 6.71882 409.175 20.9067L695.148 307.627C722.773 335.252 722.773 380.799 695.148 409.173C667.523 437.548 621.976 436.799 593.601 409.173L358.401 173.227L122.455 409.173C94.8293 436.799 49.2826 436.799 20.9079 409.173C-7.4614 381.543 -6.7174 335.996 21.6579 307.627H21.6599Z",
    fill: "#DF9F1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopArrowSecondary);
export default __webpack_public_path__ + "static/media/topArrowSecondary.f88e2be243079fa67d8e6b5c0d16938b.svg";
export { ForwardRef as ReactComponent };